import { Component } from '@angular/core';

@Component({
	selector: 'mfp-weight-balance',
	templateUrl: './weight-balance.component.html',
	styleUrls: ['./weight-balance.component.less'],
})
export class WeightBalanceComponent {}
